module.exports = __webpack_public_path__ + "img/tutor4.4e65bfc5.png";